import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { StatusSwitch, Slider, Button } from 'streamlabs-beaker';
import ComponentHelper from '@/helpers/editor';
import Position from './Position.vue';
import GeneralSettings from './GeneralSettings.vue';

@Component({
  components: {
    SStatusSwitch: StatusSwitch,
    SSlider: Slider,
    SButton: Button,
    Position,
    GeneralSettings,
  },
})
export default class VideoSettings extends EditorBase {
  muted: boolean = true;
  volume: number = 100;
  loop: boolean = true;

  get videoUrl(): string {
    return this.selectedComponent?.value || '';
  }

  get filename(): string {
    if (!this.selectedComponent || !this.selectedComponent.value) return '';

    let name = this.selectedComponent.value.split('/').pop();

    if (name.length > 10) name = `${name.slice(0, 5)}...${name.slice(-4)}`;

    return name;
  }

  get placeholderVideoSrc(): string {
    return ComponentHelper.defaultVideoSettings.value;
  }

  mounted() {
    this.loadSettings();
  }

  loadSettings() {
    if (!this.selectedComponent) return;

    this.muted = this.selectedComponent.metadata.muted;
    this.loop = this.selectedComponent.metadata.loop;
    this.volume = this.selectedComponent.metadata.volume;
  }

  onRemove() {
    const data = {
      id: this.selectedComponent.id,
      value: this.placeholderVideoSrc,
    };

    this.onComponentUpdate(data);
  }

  updateVolume(value) {
    this.volume = value;
  }
}
